import { render, staticRenderFns } from "./VenueTaskReviewStep.vue?vue&type=template&id=5b622442&"
import script from "./VenueTaskReviewStep.vue?vue&type=script&lang=js&"
export * from "./VenueTaskReviewStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports